export default __webpack_public_path__ + "static/media/rozbudowa0.ae28f88e.svg";